<div class="auth-callback-container">
  <div class="loading-spinner">
    <h3>{{ message }}</h3>
    <p>{{ subMessage }}</p>
    <div *ngIf="isProcessing" class="spinner">
      <div class="spinner-inner"></div>
    </div>
    <div *ngIf="error" class="error-message">
      <p>❌ {{ errorMessage }}</p>
    </div>
  </div>
</div>